import axios from "@/gateway/backendapi";

const branchService = {
  getBranches() {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/Branching/GetBranchesBasicInformation")
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          /*eslint no-undef: "warn"*/
          NProgress.done();
          if (error.response) {
            reject(error.response);
          } else {
            reject(error);
          }
        });
    });
  },
};

export default branchService;
